<template>
  <div class="invoice-list">
    <Title :icon="icon" title="发票信息"> </Title>
    <div style="padding: 12px">
      <a-table
        bordered
        :data-source="list"
        :pagination="false"
        rowKey="id"
      >
        <a-table-column title="发票号码" data-index="invoiceCode" align="center" />
        <a-table-column title="发票类型" align="center">
          <template slot-scope="text">
            <DataDictFinder dictType="invoiceType" :dictValue="text.type" />
          </template>
        </a-table-column>
        <a-table-column title="发票状态" align="center">
          <template slot-scope="text">
            <DataDictFinder
              dictType="invoiceStatus"
              :dictValue="text.status"
              iconType="badge"
            />
          </template>
        </a-table-column>
        <a-table-column title="业务内容" data-index="business" />
        <a-table-column title="开票日期" data-index="invoiceDate" align="center" />
        <a-table-column title="销售单位" data-index="salesUnitName" />
        <a-table-column title="欠款单位" data-index="buyerUnitName" />
        <a-table-column title="不含税收入(元)" align="right">
          <template slot-scope="text">
            <span>{{ text.itemsPrice }}</span>
          </template>
        </a-table-column>
        <a-table-column title="税额(元)" align="right">
          <template slot-scope="text">
            <span>{{ text.itemsTax }}</span>
          </template>
        </a-table-column>
        <a-table-column title="税率" align="right">
          <template slot-scope="text">
            <span v-if="typeof text.taxRate === 'number'">{{ text.taxRate }}%</span>
          </template>
        </a-table-column>
        <a-table-column title="发票金额(元)" align="right">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ text.totalPriceLowercase }}</span>
          </template>
        </a-table-column>
        <a-table-column title="开票人" data-index="drawer" align="center" />
      </a-table>
    </div>
  </div>
</template>

<script>
import Title from "../title";
export default {
  components: {
    Title,
  },

  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      icon: require("@/assets/accounts-receivable/icon-3.png"),
    };
  },

  computed: {
    list() {
      return Array.isArray(this.detail.invoiceList) ? this.detail.invoiceList : [];
    },
  },
};
</script>

<style lang="less" scoped>
.invoice-list {
  background-color: #fff;
  margin: 8px;
}
</style>
